export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-8-b06fb1c68668a016f75651166e82870d.png";